import NumberAnimation from 'components/NumberAnimation'
import { useAppSelector } from 'src/store/hooks'
import { getGoldCurrencySelector } from 'store/modules/currencies/selectors'

import classes from './styles.module.scss'

function GoldCurrency() {
  const goldCurrency = useAppSelector(getGoldCurrencySelector)

  if (goldCurrency) {
    return (
      <div className={`mt-typography-caption ${classes.curencyText}`}>
        <img
          src={`${process.env.IMG_ORIGIN}/coin-icon.svg`}
          className={classes.icon}
          alt={'gold coin icon'}
          width={14}
          height={16}
        />
        <span data-test='header-goldcoins-value'>
          GC <NumberAnimation amount={goldCurrency.amount} currency='GC' />
        </span>
      </div>
    )
  }

  return null
}

export default GoldCurrency
